import React from 'react';
import { Content } from './shared';

const AetnaApparel = () => (
  <Content>
    The clothes and shoes are half the fun. Find a list of participating retailers on the Aetna
    website and enjoy your discount.
    <ol>
      <li>Log into your Aetna account to access LifeMart.</li>

      <li>Go to Wellness {'>'} Fitness Gear.</li>

      <li>Browse your deals and click View Deal to visit the retailer's website.</li>
    </ol>
  </Content>
);

export default AetnaApparel;
